import React, { useRef, useEffect } from 'react';
import { Send, Square } from 'lucide-react';
import { useTranslation } from 'react-i18next';

interface Props {
  onSend: (content: string) => void;
  isStreaming: boolean;
  onStop: () => void;
  isOpen: boolean;
}

export default function AIInput({ onSend, isStreaming, onStop, isOpen }: Props) {
  const { t } = useTranslation();
  const [input, setInput] = React.useState('');
  const inputRef = useRef<HTMLInputElement>(null);

  useEffect(() => {
    if (isOpen) inputRef.current?.focus();
  }, [isOpen]);

  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    if (!input.trim() || isStreaming) return;
    onSend(input.trim());
    setInput('');
  };

  return (
    <form onSubmit={handleSubmit} className="p-4 border-t border-white/8">
      <div className="flex gap-2">
        <input
          ref={inputRef}
          type="text"
          value={input}
          onChange={e => setInput(e.target.value)}
          placeholder={t('aiAssistant.typeMessage')}
          disabled={isStreaming}
          className="flex-1 px-3 py-2 rounded-lg bg-white/2 border border-white/8 text-sm text-white placeholder:text-[#9a9aac] focus:outline-hidden focus:border-iris-500/50 disabled:opacity-50"
        />
        {isStreaming ? (
          <button
            type="button"
            onClick={onStop}
            className="p-2 rounded-lg bg-red-600/20 text-red-400 hover:bg-red-600/30 transition-colors"
          >
            <Square size={18} />
          </button>
        ) : (
          <button
            type="submit"
            disabled={!input.trim()}
            className="p-2 rounded-lg bg-iris-600 text-[#0C0C12] hover:bg-iris-500 transition-colors disabled:opacity-50 disabled:cursor-not-allowed"
          >
            <Send size={18} />
          </button>
        )}
      </div>
    </form>
  );
}
